import styled from 'styled-components';

export const PublicationsContainer = styled.div`
  padding: 2rem;
`;

export const SectionTitle = styled.h2`
  color: #003366;
  margin-bottom: 1rem;
`;

export const PublicationsList = styled.ul`
  list-style: none;
  padding: 0;
`;

export const PublicationItem = styled.li`
  margin-bottom: 1.5rem;
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: 5px;
`;

export const PublicationTitle = styled.h3`
  color: #0056b3;
`;

export const PublicationAuthors = styled.p`
  font-style: italic;
`;

export const PublicationJournal = styled.p`
  margin-top: 0.5rem;
`;